<template>
    <div class="modal fade segment-proposal-modal" :id="modalId" data-bs-backdrop="static" aria-labelledby="segment-refine-proposal-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 pb-0">
                    <div class="d-flex align-items-start w-100">
                        <div class="flex-grow-1" style="min-width: 0; margin-right: 1rem;">
                            <h4 class="h6 fw-semibold mt-2 mb-2 text-center text-sm-start">Refined Audience Definition</h4>
                        </div>
                        <div class="d-flex align-items-center" style="flex: 0 0 auto;">
                            <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" aria-label="Close" @click="handleClose">
                                <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt="">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <div v-if="loading" class="text-center py-4">
                        <div class="spinner-border text-primary" role="status"></div>
                        <p class="mt-2">Loading suggestion...</p>
                    </div>
                    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
                    <div v-else-if="localProposal" class="d-flex flex-column gap-3">
                        <FilterDefinitionCard
                            :filter="localProposal"
                            title="Audience Definition"
                            :show-expand-icon="false"
                            empty-message="No filter proposal available."
                        />
                        <div v-if="localProposal.reasoning" class="filter-definition-card">
                            <div class="card segment-proposal-card">
                                <div class="card-body p-3">
                                    <h4 class="h6 fw-semibold mb-0"><img class="icon me-2" src="/img/icons/avid-icons/edna.svg" alt=""> Reasoning</h4>
                                    <div class="formatted-logic text-muted mt-2" style="white-space: pre-line;">{{ localProposal.reasoning }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center py-4 text-muted">No suggestion to display.</div>
                </div>
                <div v-if="!loading && !error" class="modal-footer border-top-0 pt-0">
                    <button type="button" class="btn btn-secondary" @click="onRefine" :disabled="submitting">
                        <img class="icon me-2" src="/img/icons/avid-icons/edna.svg" alt="">
                        Refine
                    </button>
                    <button type="button" class="btn btn-primary" @click="onApply" :disabled="submitting || !localProposal">
                        <span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Apply
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import FilterDefinitionCard from '../components/FilterDefinitionCard.vue';

export default defineComponent({
    name: 'SegmentRefineProposalModal',
    components: { FilterDefinitionCard },
    props: {
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modalId: 'segment-refine-proposal-modal-' + Date.now(),
            segmentSuggestionId: null,
            localProposal: null,
            loading: false,
            error: null,
            submitting: false,
        };
    },
    methods: {
        show(segmentSuggestionId) {
            this.segmentSuggestionId = segmentSuggestionId;
            this.localProposal = null;
            this.error = null;
            this.loading = true;
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                let modal = window.bootstrap.Modal.getInstance(modalEl);
                if (!modal) modal = new window.bootstrap.Modal(modalEl);
                modal.show();
            }
            this.loadSuggestion();
        },
        async loadSuggestion() {
            if (!this.segmentSuggestionId || !this.client?.url) {
                this.loading = false;
                return;
            }
            try {
                const response = await window.axios.get(`/api/segment-suggestion/${this.client.url}/${this.segmentSuggestionId}`);
                const suggestion = response.data.segment_suggestion || null;
                if (!suggestion) {
                    this.error = 'Suggestion not found.';
                } else {
                    this.localProposal = {
                        ...(suggestion.filter || {}),
                        reasoning: suggestion.reasoning ?? null,
                    };
                }
            } catch (e) {
                this.error = e.response?.data?.error || e.response?.data?.message || 'Failed to load suggestion.';
            } finally {
                this.loading = false;
            }
        },
        onApply() {
            if (!this.localProposal) return;
            this.submitting = true;
            const filter = {
                logic_units: this.localProposal.logic_units ?? [],
                filter_logic: this.localProposal.filter_logic ?? '',
                filter_ui: 'simple',
                filter_option: 'custom',
                logic_units_modification: 0,
            };
            this.$emit('apply', filter);
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                const modal = window.bootstrap.Modal.getInstance(modalEl);
                if (modal) modal.hide();
            }
            this.submitting = false;
        },
        onRefine() {
            this.$emit('refine', {
                previousResponseId: this.localProposal?.response_id,
                currentFilter: this.localProposal,
            });
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                const modal = window.bootstrap.Modal.getInstance(modalEl);
                if (modal) modal.hide();
            }
        },
        handleClose() {},
    },
});
</script>
